import React from 'react';
import { Clock, CalendarCheck, BedDouble, RotateCw, CalendarDays, Footprints } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';

const STAT_ICONS = [Clock, CalendarCheck, BedDouble, RotateCw, CalendarDays, Footprints];

/**
 * "Your Guide to Successful [Procedure]" section — cream background with a
 * left-side accent heading + paragraph and a 2×3 grid of peach stat cards.
 */
const TreatmentGuide = ({ heading = 'Successful Treatment', description = '', stats = [] }) => {
  const { t } = useLang();
  if (!stats || stats.length === 0) return null;

  return (
    <section
      className="bg-[#f5ede2] text-[#0B3D2E] py-20 md:py-28"
      data-testid="treatment-guide-section"
    >
      <div className="max-w-[1280px] mx-auto px-6 grid md:grid-cols-2 gap-14 md:gap-16 items-start">
        {/* Left: heading + copy */}
        <div>
          <h2 className="font-serif-display leading-[1.05]">
            <span className="block text-4xl md:text-5xl text-[#0B3D2E]">{t('guide.yourGuideTo')}</span>
            <span className="block text-4xl md:text-6xl italic text-[#D4AF37] mt-2">
              {heading}
            </span>
          </h2>
          {description && (
            <p className="mt-8 text-[17px] leading-[1.9] text-[#0B3D2E]/70 max-w-xl">
              {description}
            </p>
          )}
        </div>

        {/* Right: 2×3 stat grid */}
        <div className="grid grid-cols-2 gap-5 md:gap-6">
          {stats.slice(0, 6).map(([label, value], i) => {
            const Icon = STAT_ICONS[i % STAT_ICONS.length];
            return (
              <div
                key={label + i}
                data-testid={`guide-stat-${i}`}
                className="bg-white rounded-3xl p-6 md:p-7 shadow-[0_12px_30px_-18px_rgba(11,61,46,0.25)] border border-[#D4AF37]/20 card-hover"
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5"
                  style={{ background: '#F6E3A1' }}
                >
                  <Icon className="w-6 h-6 text-[#D4AF37]" strokeWidth={1.6} />
                </div>
                <div className="font-serif-display text-lg md:text-xl text-[#0B3D2E] leading-snug">
                  {label}
                </div>
                <div className="mt-2 text-sm text-[#0B3D2E]/65">{value}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TreatmentGuide;
